// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sb0im","controls":"styles_controls__2kPja","charLimit":"styles_charLimit__2C1FW","input":"styles_input__2cl-c","send":"styles_send__FAF1f"};